import React, { memo } from 'react';
import classNames from 'classnames';
import cls from '../MeasurementsModal.module.css';
import { useMeasurementsModalBody } from './useMeasurementsModalBody';
import { Openings } from './Openings/Openings';
import { Additionally } from './Additionally/Additionally';
import { MainInfo } from './MainInfo/MainInfo';
import { Calculations } from './Calculations/Calculations';
import { Comment } from './Comment/Comment';
import { UploadImage } from './UploadImage/UploadImage';

export const MeasurementsModalBody = memo(({}) => {
    const {} = useMeasurementsModalBody();

    return (
        <div className={classNames(cls.modalBody)}>
            <MainInfo />
            <Openings />
            <Calculations />
            <Additionally />
            <Comment />
            <UploadImage />
        </div>
    );
});
